import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _SENTIMENT_COLOR;
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@nerdwallet/currency';
import { ProductCardContentTabEnum } from '../types/graphql/generated-types';
export var SEE_YOUR_APPROVAL_ODDS = 'See your approval odds';
export var GET_YOUR_FREE_CREDIT_SCORE = 'Get your free credit score';
export var LOA_CTA_TOOLTIP_LABEL = 'Recommended Credit Score';
export var LOA_CTA_TOOLTIP_CONTENT = 'A credit score in or above the recommended range means you have a higher chance of approval, but doesn’t guarantee it. Use this link to create an account and connect your credit score with TransUnion to get an estimate of your approval odds based on your credit score and other factors.';
export var UNAPPROVED_INFO_LINK = 'https://www.nerdwallet.com/article/credit-cards/good-credit-still-rejected-for-card';
export var LOA_CTA_TOOLTIP_WITH_ARTICLE = /*#__PURE__*/React.createElement(React.Fragment, null, "".concat(LOA_CTA_TOOLTIP_CONTENT, " "), /*#__PURE__*/React.createElement(Link, {
  href: UNAPPROVED_INFO_LINK
}, "Read more"), ".");
// This is the string constant used to represent showing the default drivers
// for a given product.
export var DEFAULT_DRIVER_GROUP = 'DEFAULT_DRIVER_GROUP';

/**
 * The tab sections within a product card.
 * @deprecated In favor of direct usage of ProductCardContentTabEnum.
 */
export var CONTENT_TABS = {
  KEY_FACTS: ProductCardContentTabEnum.KeyFacts,
  PRODUCT_DETAILS: ProductCardContentTabEnum.ProductDetails,
  PROS_CONS: ProductCardContentTabEnum.ProsCons,
  WHY_WE_LIKE_IT: ProductCardContentTabEnum.WhyWeLikeIt
};

/**
 * The default hierarchy around which to organize tab content.
 */
export var DEFAULT_TAB_ORDER = [ProductCardContentTabEnum.WhyWeLikeIt, ProductCardContentTabEnum.ProsCons, ProductCardContentTabEnum.ProductDetails, ProductCardContentTabEnum.KeyFacts];
export var PREHEADER_TYPE;
(function (PREHEADER_TYPE) {
  PREHEADER_TYPE["PLAIN_TEXT"] = "PLAIN_TEXT";
  PREHEADER_TYPE["DECORATED_TEXT"] = "DECORATED_TEXT";
  PREHEADER_TYPE["BADGE"] = "BADGE";
  PREHEADER_TYPE["BADGE_2022"] = "BADGE_2022";
  PREHEADER_TYPE["BADGE_AWARDS"] = "BADGE_AWARDS";
})(PREHEADER_TYPE || (PREHEADER_TYPE = {}));
export var PREHEADER_TRK_LOCATION;
(function (PREHEADER_TRK_LOCATION) {
  PREHEADER_TRK_LOCATION["BEST_OF_BADGE"] = "BestOfBadge";
  PREHEADER_TRK_LOCATION["PREHEADER"] = "Preheader";
})(PREHEADER_TRK_LOCATION || (PREHEADER_TRK_LOCATION = {}));
export var SENTIMENT_TYPE;
(function (SENTIMENT_TYPE) {
  SENTIMENT_TYPE["GOOD"] = "GOOD";
  SENTIMENT_TYPE["NEUTRAL"] = "NEUTRAL";
  SENTIMENT_TYPE["BAD"] = "BAD";
})(SENTIMENT_TYPE || (SENTIMENT_TYPE = {}));
export var SENTIMENT_COLOR = (_SENTIMENT_COLOR = {}, _defineProperty(_SENTIMENT_COLOR, SENTIMENT_TYPE.GOOD, 'green'), _defineProperty(_SENTIMENT_COLOR, SENTIMENT_TYPE.NEUTRAL, 'neutral-darkest'), _defineProperty(_SENTIMENT_COLOR, SENTIMENT_TYPE.BAD, 'red'), _SENTIMENT_COLOR);
export var TRK_PRODUCT_LOCATION = 'MarketplaceProductCard';
export var COMPONENT_ANALYTICS_NAME = 'product_card';
export var MORE_DETAILS = "".concat(COMPONENT_ANALYTICS_NAME, "_more_details");

/**
 * PropTypes to be expected in a structured content object.
 *
 * @type {Object}
 */

/**
 * PropTypes to be expected in a structured content object.
 *
 * @type {Object}
 */
export var StructuredContentPropType = PropTypes.shape({
  type: PropTypes.string,
  version: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  props: PropTypes.object
});
export var STATIC_IMAGE_HEIGHT = 140; // @imageMaxHeight
export var STATIC_IMAGE_WIDTH = 221; // @imageWidthDesktop